const Pencil = ({
  size = 20,
  width,
  height,
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? size}
    height={height ?? size}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <g data-name="Layer 2">
      <path d="M22 22.75H10a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 0 1.5zM3 21.71a1.25 1.25 0 0 1-1.25-1.34L2.08 16a1.74 1.74 0 0 1 .51-1.11l13.2-13.15a1.78 1.78 0 0 1 2.47 0l3.47 3.46a1.76 1.76 0 0 1 0 2.48l-13.2 13.2a1.75 1.75 0 0 1-1.1.5l-4.33.33zM17 2.72a.24.24 0 0 0-.18.08L3.65 16a.26.26 0 0 0-.07.16l-.3 4 4-.3a.25.25 0 0 0 .16-.08L20.67 6.62a.27.27 0 0 0 0-.36L17.2 2.8a.23.23 0 0 0-.2-.08z" />
      <path d="M18.39 10.71a.71.71 0 0 1-.53-.22L13 5.61a.75.75 0 0 1 1-1.06l4.89 4.88a.75.75 0 0 1 0 1.06.74.74 0 0 1-.5.22z" />
    </g>
  </svg>
);

export default Pencil;
